/**
 * Heure du serveur vue du téléphone. Les saisies différées partent datées de
 * l'instant de l'appui ; l'API refuse une heure en avance de plus de deux
 * minutes sur la sienne. Une horloge de téléphone déréglée se corrige donc à
 * chaque réponse de l'API, par son en-tête `Date`, sans jamais rien stocker.
 */

/** Au-delà, l'aller-retour est trop incertain pour mesurer quoi que ce soit. */
const ALLER_RETOUR_MAX_MS = 5_000;
/** En deçà, l'écart vient de l'arrondi de l'en-tête à la seconde : on l'ignore. */
const SEUIL_DECALAGE_MS = 2_000;
/** L'en-tête `Date` est tronqué à la seconde : son milieu est une demi-seconde plus loin. */
const DEMI_SECONDE_MS = 500;

let decalage = 0;

/**
 * Mesure l'écart entre le serveur et le téléphone : l'heure du serveur est
 * rapportée au milieu de l'aller-retour. Une mesure douteuse (en-tête absent ou
 * illisible, aller-retour négatif ou trop long) laisse la précédente en place.
 */
export function noterHeureServeur(enteteDate: string | null, envoyeLe: number, recuLe: number): void {
  if (!enteteDate) return;
  const serveur = Date.parse(enteteDate);
  if (Number.isNaN(serveur)) return;
  const allerRetour = recuLe - envoyeLe;
  if (allerRetour < 0 || allerRetour > ALLER_RETOUR_MAX_MS) return;
  const mesure = serveur + DEMI_SECONDE_MS - (envoyeLe + recuLe) / 2;
  decalage = Math.abs(mesure) < SEUIL_DECALAGE_MS ? 0 : Math.round(mesure);
}

/** Heure du serveur estimée, en millisecondes depuis l'époque Unix. */
export function maintenantServeur(): number {
  return Date.now() + decalage;
}

/** Avance (positive) ou retard (négatif) du serveur sur le téléphone, en millisecondes. */
export function decalageHorloge(): number {
  return decalage;
}

/** Tests : oublie la dernière mesure. */
export function reinitialiserHorloge(): void {
  decalage = 0;
}
